import { EXERCISE_PREFIX } from '../actionTypePrefixes';
import { addActionTypePrefix } from '../util/addActionTypePrefix';

export const INIT = addActionTypePrefix('INIT', EXERCISE_PREFIX);
export const init = (
   exerciseDocument,
   savedProgress,
   levelSelect,
   nextConfig
) => ({
   type: INIT,
   exerciseDocument,
   savedProgress,
   levelSelect,
   nextConfig,
});

export const SET_STAGE = addActionTypePrefix('SET_STAGE', EXERCISE_PREFIX);
export const setStage = (stage) => ({ type: SET_STAGE, stage });

export const SET_PROGRESS = addActionTypePrefix(
   'SET_PROGRESS',
   EXERCISE_PREFIX
);
export const setProgress = (progress) => ({ type: SET_PROGRESS, progress });

export const ADD_SCORE = addActionTypePrefix('ADD_SCORE', EXERCISE_PREFIX);
export const addScore = (score) => ({ type: ADD_SCORE, score });

// Progress exercise (next button click)....
export const ADVANCE_EXERCISE_STAGE = addActionTypePrefix(
   'ADVANCE_EXERCISE_STAGE',
   EXERCISE_PREFIX
);
export const advanceExerciseStage = () => ({ type: ADVANCE_EXERCISE_STAGE });
// Prepare Next Session
export const PREPARE_NEXT_SESSION = addActionTypePrefix(
   'PREPARE_NEXT_SESSION',
   EXERCISE_PREFIX
);
export const prepareNextSession = () => ({
   type: PREPARE_NEXT_SESSION,
});
// General exercise session ready
export const COMMON_EXERCISE_READY = addActionTypePrefix(
   'COMMON_EXERCISE_READY',
   EXERCISE_PREFIX
);
export const commonExerciseReady = () => ({
   type: COMMON_EXERCISE_READY,
});
// specific exercise session ready
export const EXERCISE_READY = addActionTypePrefix(
   'EXERCISE_READY',
   EXERCISE_PREFIX
);
export const exerciseReady = () => ({
   type: EXERCISE_READY,
});
// check for, load, and wait for tutorial to be loaded if applicable
export const AWAIT_TUTORIAL = addActionTypePrefix(
   'AWAIT_TUTORIAL',
   EXERCISE_PREFIX
);
export const awaitTutorial = () => ({
   type: AWAIT_TUTORIAL,
});
// Start next session
export const START_NEXT_SESSION = addActionTypePrefix(
   'START_NEXT_SESSION',
   EXERCISE_PREFIX
);
export const startNextSession = () => ({ type: START_NEXT_SESSION });
// Prepare next challenge
export const PREPARE_NEXT_CHALLENGE = addActionTypePrefix(
   'PREPARE_NEXT_CHALLENGE',
   EXERCISE_PREFIX
);
export const prepareNextChallenge = () => ({
   type: PREPARE_NEXT_CHALLENGE,
});
// General exercise challenge ready
export const COMMON_EXERCISE_CHALLENGE_READY = addActionTypePrefix(
   'COMMON_EXERCISE_CHALLENGE_READY',
   EXERCISE_PREFIX
);
export const commonExerciseChallengeReady = () => ({
   type: COMMON_EXERCISE_CHALLENGE_READY,
});
// specific exercise challenge ready
export const EXERCISE_CHALLENGE_READY = addActionTypePrefix(
   'EXERCISE_CHALLENGE_READY',
   EXERCISE_PREFIX
);
export const exerciseChallengeReady = () => ({
   type: EXERCISE_CHALLENGE_READY,
});
// start next challenge
// NOTE: refresh aux queue here
// (progress exercise)
// complete challenge
// complete session
export const START_NEXT_CHALLENGE = addActionTypePrefix(
   'START_NEXT_CHALLENGE',
   EXERCISE_PREFIX
);
export const startNextChallenge = (moduleId) => {
   const action = {
      type: START_NEXT_CHALLENGE,
   };
   if (moduleId) {
      action.moduleId = moduleId;
   }
   return action;
};

export const SUBMIT_ANSWER = addActionTypePrefix(
   'SUBMIT_ANSWER',
   EXERCISE_PREFIX
);
export const submitAnswer = () => ({
   type: SUBMIT_ANSWER,
});

export const PRE_SUBMIT_ANSWER = addActionTypePrefix(
   'PRE_SUBMIT_ANSWER',
   EXERCISE_PREFIX
);
export const preSubmitAnswer = () => ({
   type: PRE_SUBMIT_ANSWER,
});

export const COMPLETE_SESSION = addActionTypePrefix(
   'COMPLETE_SESSION',
   EXERCISE_PREFIX
);
export const completeSession = (isSubscribed) => ({
   type: COMPLETE_SESSION,
   isSubscribed,
});

export const TUTORIAL_ACTION = addActionTypePrefix(
   'TUTORIAL_ACTION',
   EXERCISE_PREFIX
);
export const tutorialAction = (action) => ({
   type: TUTORIAL_ACTION,
   action,
});

export const SET_MODULE_LOADING = addActionTypePrefix(
   'SET_MODULE_LOADING',
   EXERCISE_PREFIX
);
export const setModuleLoading = (id) => ({
   type: SET_MODULE_LOADING,
   id,
});

export const LOAD_MODULE = addActionTypePrefix('LOAD_MODULE', EXERCISE_PREFIX);
export const loadModule = (id) => ({
   type: LOAD_MODULE,
   id,
});

export const ADD_MODULE = addActionTypePrefix('ADD_MODULE', EXERCISE_PREFIX);
export const addModule = (moduleData) => ({
   type: ADD_MODULE,
   moduleData,
});

export const SET_SELECTED_MODULES = addActionTypePrefix(
   'SET_SELECTED_MODULES',
   EXERCISE_PREFIX
);
export const setSelectedModules = (selectedModules) => ({
   type: SET_SELECTED_MODULES,
   selectedModules,
});

export const REFRESH_MODULE_QUEUE = addActionTypePrefix(
   'REFRESH_MODULE_QUEUE',
   EXERCISE_PREFIX
);
export const refreshModuleQueue = (count, config = {}) => ({
   type: REFRESH_MODULE_QUEUE,
   count,
   ...config,
});

export const REFRESH_CURRENT_MODULE = addActionTypePrefix(
   'REFRESH_CURRENT_MODULE',
   EXERCISE_PREFIX
);
export const refreshCurrentModule = () => ({
   type: REFRESH_CURRENT_MODULE,
});

export const REPLACE_EXERCISE_DOCUMENT = addActionTypePrefix(
   'REPLACE_EXERCISE_DOCUMENT',
   EXERCISE_PREFIX
);
export const replaceExerciseDocument = (exerciseDocument) => ({
   type: REPLACE_EXERCISE_DOCUMENT,
   exerciseDocument,
});

export const EMULATE_EXERCISE_FOR_TUTORIAL = addActionTypePrefix(
   'EMULATE_EXERCISE_FOR_TUTORIAL',
   EXERCISE_PREFIX
);
export const emulateExerciseForTutorial = () => ({
   type: EMULATE_EXERCISE_FOR_TUTORIAL,
});

export const SET_METADATA = addActionTypePrefix(
   'SET_METADATA',
   EXERCISE_PREFIX
);
export const setMetadata = (metadata) => ({ type: SET_METADATA, metadata });

export const SET_PROMPT = addActionTypePrefix('SET_PROMPT', EXERCISE_PREFIX);
export const setPrompt = (prompt) => ({
   type: SET_PROMPT,
   prompt,
});
